import instance from '@/utils/instance';

//查询购物车
export function getConsumerOrderQueryCart(params) {
	return instance({
		url: `/webL_api/consumer/order/queryCart`,
		method: 'get'
	});
}

//添加到购物车
export function postConsumerOrderAddCart(params) {
	return instance({
		url: `/webL_api/consumer/order/addCart`,
		method: 'post',
		data: params
	});
}

//移除购物车商品
export function postConsumerOrderRemoveCart(params) {
	return instance({
		url: `/webL_api/consumer/order/removeCart`,
		method: 'post',
		data: params
	});
}

//更新购物车商品
export function postConsumerOrderUpdateCart(params) {
	return instance({
		url: `/webL_api/consumer/order/updateCart`,
		method: 'post',
		data: params
	});
}

